module.exports = __webpack_public_path__ + "7ae23eba6ce972611e1b1cd260f767a4.pdf";